import { Typography } from '@/components/ui/typography'
import { useFormContext } from '@/lib/form-contexts'
import { MediaUploadUsage } from '@/lib/enums/MediaUploadUsage'
import { PhotoManagerDefaultUploadDestination } from '@/lib/photo-manager-config'
import { Image } from 'lucide-react'
import ButtonLinkSelector from './ButtonLinkSelector'
import { HomepageBannerCompositionFields } from './HeroCompositionFields'

const PREFIX = 'pages./.blocks.hero'
const name = (str) => `${PREFIX}.${str}`
const hero = (str) => name(`hero.0.${str}`)

const HeroSectionForm = ({
  allowInheritedLayout = false,
  automaticButtonDestination = false,
  trackSeasonalCustomization = false,
}) => {
  const form = useFormContext()
  const markCustomized = () => {
    if (!trackSeasonalCustomization) return
    form.setFieldValue('seasonal.hero_mode', 'local')
    form.setFieldValue('seasonal.mark_reviewed', true)
  }
  const applyHeroFocalPoint = (media) => {
    form.setFieldValue(hero('props.imageFocalPointX'), media.focal_point_x)
    form.setFieldValue(hero('props.imageFocalPointY'), media.focal_point_y)
    markCustomized()
  }
  return (
    <div className="flex flex-col gap-y-6 mb-4">
      <div>
        <form.AppField name={hero('media.0')} listeners={{ onChange: markCustomized }}>
          {(field) => (
            <field.MediaUploadInput
              className="max-w-lg"
              defaultUploadDestination={PhotoManagerDefaultUploadDestination.BannerImages}
              uploadUsage={MediaUploadUsage.StorefrontHero.Value}
              allowFocalPoint
              onFocalPointChange={applyHeroFocalPoint}
              label={
                <Typography variant="emphasis" className="flex items-center gap-2">
                  <Image className="size-5" /> Homepage banner image
                </Typography>
              }
            />
          )}
        </form.AppField>
      </div>
      <HomepageBannerCompositionFields
        fieldRoot={hero('props')}
        allowInheritedLayout={allowInheritedLayout}
        buttonDestination={
          !automaticButtonDestination ? (
            <ButtonLinkSelector name={hero} onChange={markCustomized} />
          ) : null
        }
        onChange={markCustomized}
      />
    </div>
  )
}

export default HeroSectionForm
